import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
import authStudentReducer from "./slices/students/authStudentSlice";
import authTeacherReducer from "./slices/teachers/authTeacherSlice";
import globalReducer from './slices/students/globalSlice';

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        authStudent: authStudentReducer,
        authTeacher: authTeacherReducer,
        global: globalReducer,

    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true,
});

export default store;